<div class="notification-container">
  <!-- Bell Button -->
  <button 
    class="notification-bell"
    (click)="toggleNotifications()"
    [class.has-notifications]="unreadCount > 0"
  >
    <svg 
      [class.text-emerald-500]="unreadCount > 0"
      [class.text-gray-400]="!unreadCount"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
    >
      <path 
        stroke-linecap="round" 
        stroke-linejoin="round" 
        stroke-width="2" 
        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
      />
    </svg>

    <span 
      *ngIf="unreadCount > 0"
      class="notification-badge"
    >
      {{ unreadCount }}
    </span>
  </button>

  <!-- Notifications Dropdown -->
  <div 
    *ngIf="isNotificationsOpen"
    [@dropdownAnimation]
    class="notifications-dropdown"
  >
    <app-notifications-header
      [selectedFilter]="selectedFilter"
      [unreadCount]="unreadCount"
      [hasUnreadNotifications]="unreadCount > 0"
      (closeNotifications)="toggleNotifications()"
      (filterChange)="onFilterChange($event)"
      (markAllAsRead)="handleMarkAllAsRead()"
    ></app-notifications-header>

    <div class="notifications-content">
      <ng-container *ngIf="!isLoading; else loading">
        <ng-container *ngIf="filteredNotifications$ | async as notifications">
          <ng-container *ngIf="notifications.length > 0; else noNotifications">
            <app-notification-item
              *ngFor="let notification of notifications"
              [notification]="notification"
              (notificationClick)="handleNotificationClick($event)"
              (actionClick)="handleActionClick($event)"
            ></app-notification-item>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-template #loading>
        <div class="loading-state">
          <div class="spinner"></div>
        </div>
      </ng-template>

      <ng-template #noNotifications>
        <div class="empty-state">
          <p>{{ 'notifications.empty' | translate }}</p>
        </div>
      </ng-template>
    </div>
  </div>
</div> 